import { createUseStyles, ComposedTheme } from '@glu/theming';

/* istanbul ignore file */
export const alertTheme = ({
  palette: { background },
  shadows,
  spacing: { unit }
}: ComposedTheme) => ({
  background: background.normal,
  border: `${unit / 8}px solid transparent`,
  borderRadius: unit / 2,
  boxShadow: `${unit / 8}px ${unit / 8}px ${unit / 2}px ${unit / 4}px ${shadows.normal}`
});

const styles = createUseStyles(({ palette: { secondary }, spacing: { unit } }: ComposedTheme) => ({
  alert: {
    width: `calc(100% - ${2 * unit}px)`,
    margin: 1 * unit
  },
  message: {
    fontSize: unit * 1.5,
    display: 'flex',
    flexDirection: 'column',
    padding: `${unit * 1.3}px 0 0`,
    width: '100%',
    '& table': {
      margin: `0 ${unit * 2}px`
    }
  },
  guidMsg: {
    display: 'flex',
    color: secondary.normal,
    fontSize: unit * 1.625,
    paddingTop: unit
  }
}));

export default styles;
